import React from "react";
import { connect } from "react-redux";
import { columns } from "./utils";
import Box from "@material-ui/core/Box";

import DataGrid, {
  Column,
  LoadPanel,
  Scrolling,
  FilterRow,
  HeaderFilter,
  Sorting,
  Editing
} from "devextreme-react/data-grid";
import {
  addModuleReferenceAction,
  updateModuleReferenceAction,
  deleteModuleReferenceAction
} from "../../../../store/actions";

const AditionalBooks = ({
  allModuleReferenceList,
  addReference,
  updateReference,
  deleteReference
}) => {
  const addBook = data => {
    const newBook = {
      type: 2,
      main: {
        name: data.name,
        description: data.description,
        source: data.source
      }
    };
    addReference(newBook);
  };

  const updateBook = data => {
    const updateBook = {
      main: {
        name: data.name,
        description: data.description,
        source: data.source
      }
    };
    updateReference(data.id, updateBook);
  };

  return (
    <div>
      <Box fontSize={14} mb={2}>
        Дополнительная литература
      </Box>
      <DataGrid
        elementAttr={{
          id: "gridContainer"
        }}
        wordWrapEnabled
        errorRowEnabled={false}
        showBorders
        dataSource={allModuleReferenceList.filter(item => item.type === 2)}
        onRowInserted={event => addBook(event.data)}
        onRowUpdated={event => updateBook(event.data)}
        onRowRemoved={event => deleteReference(event.data.id)}
      >
        {columns.map((column, idx) => (
          <Column key={idx} {...column} defaultSortOrder="asc" />
        ))}
        <Editing mode="row" allowUpdating allowDeleting allowAdding />
        <Sorting showSortIndexes={false} visible />
        <HeaderFilter visible />
        <FilterRow visible />
        <Scrolling mode="virtual" />
        <LoadPanel enabled />
      </DataGrid>
    </div>
  );
};

const mapStateToProps = state => ({
  allModuleReferenceList: state.modules.allModuleReferenceList
});

const mapDispatchToProps = dispatch => ({
  addReference: reference => dispatch(addModuleReferenceAction(reference)),
  updateReference: (idReference, data) =>
    dispatch(updateModuleReferenceAction(idReference, data)),
  deleteReference: idReference =>
    dispatch(deleteModuleReferenceAction(idReference))
});

export default connect(mapStateToProps, mapDispatchToProps)(AditionalBooks);
